import React, { useEffect, useMemo, useRef, useState } from 'react';
import './css/PlayerListFilters.css';

export const ALL = 'All';
export const POSITION_OPTIONS = ['C', 'LW', 'RW', 'D', 'G'];

export const playerMatchesPosition = (player, positionFilter) => {
  if (!positionFilter || positionFilter === ALL) return true;

  return (player.pos || []).some((pos) =>
    String(pos)
      .split(',')
      .map((part) => part.trim())
      .includes(positionFilter)
  );
};

const PlayerListFilters = ({
  teams = [],
  positionFilter,
  onPositionChange,
  teamFilter,
  onTeamChange,
}) => {
  const [teamMenuOpen, setTeamMenuOpen] = useState(false);
  const teamDropdownRef = useRef(null);

  const sortedTeams = useMemo(() => {
    return [...teams].sort((a, b) => a.team_name.localeCompare(b.team_name));
  }, [teams]);

  const selectedTeam = sortedTeams.find((team) => team.team_key === teamFilter);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (teamDropdownRef.current && !teamDropdownRef.current.contains(event.target)) {
        setTeamMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectTeam = (teamKey) => {
    onTeamChange(teamKey);
    setTeamMenuOpen(false);
  };

  return (
    <div className="player-list-filters">
      <div className="player-list-filter" role="group" aria-label="Filter by position">
        <button
          type="button"
          className={`position-chip${positionFilter === ALL ? ' is-active' : ''}`}
          onClick={() => onPositionChange(ALL)}
        >
          All
        </button>
        {POSITION_OPTIONS.map((pos) => (
          <button
            key={pos}
            type="button"
            className={`position-chip${positionFilter === pos ? ' is-active' : ''}`}
            onClick={() => onPositionChange(pos)}
          >
            {pos}
          </button>
        ))}
      </div>

      <div className="player-list-filter team-filter" ref={teamDropdownRef}>
        <button
          type="button"
          className="team-filter-toggle"
          onClick={() => setTeamMenuOpen((open) => !open)}
          aria-haspopup="listbox"
          aria-expanded={teamMenuOpen}
        >
          {selectedTeam ? (
            <>
              <img
                src={selectedTeam.team_logo_url}
                alt=""
                className="team-filter-logo"
              />
              <span>{selectedTeam.team_name}</span>
            </>
          ) : (
            <span>All teams</span>
          )}
        </button>
        {teamMenuOpen && (
          <ul className="team-filter-menu" role="listbox">
            <li>
              <button
                type="button"
                className={`team-filter-option${teamFilter === ALL ? ' is-active' : ''}`}
                onClick={() => selectTeam(ALL)}
              >
                <span>All teams</span>
              </button>
            </li>
            {sortedTeams.map((team) => (
              <li key={team.team_key}>
                <button
                  type="button"
                  className={`team-filter-option${teamFilter === team.team_key ? ' is-active' : ''}`}
                  onClick={() => selectTeam(team.team_key)}
                >
                  <img
                    src={team.team_logo_url}
                    alt=""
                    className="team-filter-logo"
                  />
                  <span>{team.team_name}</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default PlayerListFilters;
